import { Http } from '@gamiphy/http';
import { AppGame, UserGame } from '@gamiphy/bl/game';

export class GameApi {
  public static async getAppGame(appGameId: string): Promise<AppGame> {
    const response = await Http.get<GetAppGameResponse>({
      url: `/v2/games/${appGameId}`,
    });
    return response.data.game;
  }

  public static async getAppGames(query?: GetAppGamesQuery): Promise<AppGame[] | []> {
    const response = await Http.get<GetAppGamesResponse>({
      url: '/v2/games',
      query,
    });
    return response.data.games;
  }

  public static async createAppGames(game: Omit<AppGame, 'id' | 'game' | 'createdAt' | 'app'>): Promise<AppGame> {
    const response = await Http.post<CreateAppGameResponse>({
      url: '/v2/games',
      payload: game,
    });
    return response.data.game;
  }

  public static async getUserGameFromAppGame(appGameId: string): Promise<UserGame> {
    const response = await Http.get<GetUserGameFromAppGameResponse>({
      url: `/v2/user-games/games/${appGameId}`,
    });
    return response.data.userGame;
  }

  public static async getUserGame(userGameId: string): Promise<UserGame> {
    const response = await Http.get<GetUserGameResponse>({
      url: `/v2/user-games/${userGameId}`,
    });
    return response.data.userGame;
  }

  public static async updateAppGame(id: string, data: Partial<AppGame>): Promise<AppGame> {
    const response = await Http.patch<UpdateAppGameResponse>({
      url: `/v2/games/${id}`,
      payload: data,
    });
    return response.data.game;
  }
}

export type GetAppGameResponse = {
  game: AppGame
}

export type GetAppGamesResponse = {
  games: AppGame[],
  count: number
}

export type GetAppGamesQuery = {
  enabled?: boolean
}

export type CreateAppGameResponse = {
  game: AppGame,
}

export type GetUserGameFromAppGameResponse = {
  userGame: UserGame,
}

export type GetUserGameResponse = {
  userGame: UserGame,
}
export type UpdateAppGameResponse = {
  game: AppGame
}
